class ChartService {
    lastError;
    lastErrorCode;
    axiosSource
    isSandboxMode = false;

    constructor(axios, isSandboxMode) {
        this.axios = axios
        this.isSandboxMode = isSandboxMode
    }
    
    setSandboxMode(newState) {
        this.isSandboxMode = newState
    }
    async get(opt, $t) {
        if (!opt) throw new Error($t('service.chart.missingInputs'));

        if (this.axiosSource) {
            await this.axiosSource.cancel()
        }

        const url = this.getSourceUrl(opt.source, opt.sourceIdentifier, opt.interval, $t);
        const config = this.getRequestConfig(opt)
        if (!opt.nonCancelable) {
            this.axiosSource = opt.axiosSource ?? this.axios.CancelToken.source();
            config.cancelToken = this.axiosSource.token
        }

        return await this
            .axios
            .get(
                url,
                config
            )
            .then((res) => {
                this.axiosSource = null
                return res.data
            })
            .catch((error) => {
                //  if the error is request cancelation, need to keep the loading
                if (this.axios.isCancel(error)) {
                    throw error
                }
                this.axiosSource = null
                this.#handleError(error, $t);
                return null
            })
    }

    getSourceUrl(source, identifier, interval = null, $t) {
        if (!source) throw new Error($t('service.chart.missingSource'));

        var url = '/api/'

        switch(source) {
            case 'portfolio':
                if(identifier && identifier !== 'dashboard') {
                    url += 'portfolio/'+identifier+'/chart'
                    break
                }
                url += this.isSandboxMode ? 'portfolios/chart?context=virtual' : 'portfolios/chart'
                break
            case 'share':
                if (!interval) throw new Error($t('service.chart.missingInterval'));
                url += 'chart/'+interval
                break
            // TODO: update url with the Market Analysis chart API
            case 'market':
                if (!interval) throw new Error($t('service.chart.missingInterval'));
                url += 'chart/'+interval
                break
        }

        return url
    }

    getRequestConfig(opt) {
        let config = {
            params: {},
            headers: {}
        }
        config.params = this.getRequestQuery(opt)

        return config
    }

    getRequestQuery(opt, $t) {
        if(opt.source === 'portfolio') {
            return {
                period: opt.interval,
                comparisons: opt.comparisons,
            }
        }

        if(opt.source === 'share') {
            return {
                isin: opt.sourceIdentifier,
                currency: opt.currency,
                comparisons: opt.comparisons,
            }
        }

        if(opt.source === 'market') {
            return {
                // TODO: remove this hard code when have Market Analysis chart API
                isin: 'CRYPT0000BTC',
                comparisons: opt.comparisons,
            }
        }

        throw new Error($t('service.chart.unknownSource'));
    }

    #handleError(e, $t) {
        if (
            e.constructor.name == 'Cancel' ||
            (Object.hasOwn(e, 'message') && e.message == undefined) // Firefox specific case
        ) {
            // we canceled this request, further handling not needed
            return
        }

        throw new Error($t('service.chart.generalError', { error: e.message || '' }));
    }
}

export default ChartService;
